module.exports = __webpack_public_path__ + "img/021.0c74ca12.jpg";